<template>
<!--    Sourcing-->
    <div v-if="settings.is_sourcing_mode" class="bg-gradient-to-b from-gray-130 to-transparent dark:from-gray-700 dark:to-gray-785 group relative h-[26rem] w-auto flex items-center justify-center border-b border-keyline-primary print:bg-none overflow-hidden">
        <div class="p-4 w-full h-full flex items-center justify-center">
            <div
                v-if="_.get(product, `assets.product-image.${selectedImage}`, false)"
                style="z-index: 20"
                class="absolute inset-0 hidden group-hover:at1024:flex items-center justify-center">
                <button
                    class="duration-150 absolute group-hover:block rounded bg-gray-900 opacity-50 hover:opacity-75 active:opacity-100"
                    @click="
              toggleImageDialog(
                $event,
                 {
                  title: product.item_id,
                  images: _.get(product, 'assets.product-image', _.get(product, 'display_thumbnails', [])),
                  selectedImage: selectedImage
                }
              )
            ">
                    <BaseSvg name="icon-zoom-in" class="rounded w-12 h-12 p-2 shrink-0 fill-white" />
                </button>
            </div>
            <!-- IF: a product image exists. Show the product image -->
            <img
                v-if="productImage(product, selectedImage, false)"
                :alt="'product image for ' + product.sku"
                :src="productImage(product, selectedImage, false)"
                :class="{
                'relative h-full z-10': !productImage(product, selectedImage, false).startsWith('https://marketing'),
                'relative h-full p-32 z-10 opacity-75': productImage(product, selectedImage, false).startsWith('https://marketing'),
              }">
            <!-- ELSE IF: Show the Manufacturer Logo -->
            <img
                v-else-if="productImage(product, selectedImage)"
                class="max-h-28 max-w-xs mx-auto opacity-50 dark:opacity-90"
                :src="productImage(product, selectedImage)"
                :alt="product?.vendor?.display_name + ' logo'">
            <!-- ELSE: show an Icon-Products-Cube SVG as a placeholder -->
            <BaseSvg v-else name="icon-products-cube" class="h-40 opacity-50 relative z-0" />
        </div>
        <ul
            v-if="imagesArray?.length"
            class="sourcing-thumbnails z-20 absolute top-0 left-0 p-4 flex flex-col w-fit shrink-0 items-center gap-3 mx-4 at1024:m-0 mb-4 print:hidden overflow-y-auto h-full scrollbar-hide">
            <li v-for="(_, index) in imagesArray">
                <button
                    class="rounded border border-keyline-primary overflow-hidden w-16 h-16 p-1"
                    :class="index === selectedImage ? '!border-default' : 'hover:border-gray-tier-7'"
                    @click="handleThumbnailClick(index)">
                    <img class="h-full w-auto m-auto" :src="productImage(product, index)" :alt="'product image thumbnail for ' + product.sku">
                </button>
            </li>
        </ul>
        <!-- Buttons to go left and right in image carousel            -->
        <span v-if="imagesArray?.length > 1" class="z-20 absolute bottom-4 right-4 flex items-center">
            <span class="w-full flex justify-between items-center gap-2">
                <button
                    @click="() => decrementSelectedImage()"
                    class="btn-app-icon-black-on-gray"
                    :disabled="selectedImage === 0"
                >
                    <BaseSvg name="icon-chevron-left" class="w-6 h-6" />
                </button>
                <button
                    @click="() => incrementSelectedImage()"
                    class="btn-app-icon-black-on-gray"
                    :disabled="selectedImage === _.get(product, 'assets.product-image', '').length - 1"
                >
                    <BaseSvg name="icon-chevron-right" class="w-6 h-6" />
                </button>
            </span>
        </span>
    </div>
    
<!--    Marketing-->
    <div v-else>
        <div class="group relative flex h-[300px] items-center justify-center p-4 at1024:h-[500px]">
            <span
                v-if="_.get(product, `assets.product-image.${selectedImage}`, false)"
                class="z-10 absolute inline-block opacity-0 focus-within:opacity-100 group-hover:opacity-100"
            >
              <button
                  @click="toggleImageDialog($event, {
                      title: product.item_id,
                      images: _.get(product, 'assets.product-image', _.get(product, 'display_thumbnails', [])),
                      selectedImage: selectedImage,
                   }, true)"
                  class="rounded bg-gray-700 duration-150 opacity-50 hover:opacity-75 active:opacity-100"
              >
                <BaseSvg name="icon-zoom-in" class="h-12 w-12 shrink-0 rounded fill-white p-2" aria-hidden="true" />
                <span class="sr-only">Enlarge image</span>
              </button>
            </span>
            <!-- IF: logged out and product image exists. Show the watermarked product image -->
            <img
                v-if="!user && productImage(product, selectedImage, false)"
                class="max-h-full max-w-full"
                :alt="_.get(product, `assets.product-image.${selectedImage}.alt_text`, product.sku)"
                :src="productImage(product, selectedImage, false, '', 'product-img')">
            <!-- ELSE IF: a product image exists. Show the product image -->
            <img
                v-else-if="productImage(product, selectedImage, false)"
                class="max-h-full max-w-full"
                :alt="_.get(product, `assets.product-image.${selectedImage}.alt_text`, product.sku)"
                :src="productImage(product, selectedImage, false)">
            <!-- ELSE IF: Show the Manufacturer Logo -->
            <img
                v-else-if="productImage(product, selectedImage)"
                class="max-h-28 max-w-xs mx-auto opacity-50"
                :src="productImage(product, selectedImage)"
                :alt="product?.vendor?.display_name + ' logo'">
            <!-- ELSE: show an Icon-Products-Cube SVG as a placeholder -->
            <BaseSvg v-else name="icon-products-cube" class="h-40 opacity-50 relative z-10" />
            <!-- Buttons to go left and right in image carousel            -->
            <span v-if="imagesArray?.length > 1" class="z-0 absolute inset-0 at1024:-inset-4 flex items-center">
                <span class="w-full flex justify-between items-center">
                    <button
                        @click="() => decrementSelectedImage()"
                        class="carousel-button"
                        :disabled="selectedImage === 0"
                    >
                        <BaseSvg name="icon-chevron-left" class="w-8 h-8" />
                    </button>
                    <button
                        @click="() => incrementSelectedImage()"
                        class="carousel-button"
                        :disabled="selectedImage === _.get(product, 'assets.product-image', '').length - 1"
                    >
                        <BaseSvg name="icon-chevron-right" class="w-8 h-8" />
                    </button>
                </span>
            </span>
        </div>
        <ul
            v-if="imagesArray?.length && user"
            class="overflow-x-scroll w-full relative bottom-0 left-0 right-0 flex at1024:w-fit shrink-0 items-center gap-3 at1024:m-0 mb-4 print:hidden">
            <li v-for="(image, index) in imagesArray">
                <button
                    class="rounded-sm border overflow-hidden w-16 h-16 p-1"
                    :class="index === selectedImage ? 'border-gray-tier-1' : 'border-gray-tier-7'"
                    @click="selectedImage = index">
                    <img
                        class="h-full w-auto m-auto"
                        :src="`https://assets.seclock.com/image/private/t_thumb/${_.get(product, 'assets.product-image.' + index + '.external_id', false)}`"
                        :alt="_.get(product, 'assets.product-image.' + index + '.alt_text', false)">
                </button>
            </li>
        </ul>
    </div>
</template>

<script setup>
import _ from "lodash";
import {BaseSvg} from "@/Components";
import {useAssetTransforms, useImageDialog, useUser} from "@/Composables";
import {ref} from "vue";

const props = defineProps(['product', 'user']);

const { settings } = useUser();
const { productImage } = useAssetTransforms();
const { toggleImageDialog } = useImageDialog();

const selectedImage = ref(0);

const incrementSelectedImage = () => {
    selectedImage.value++;
    scrollToThumbnail(selectedImage.value);
};

const decrementSelectedImage = () => {
    selectedImage.value--;
    scrollToThumbnail(selectedImage.value);
};

const imagesArray = _.get(props.product, 'assets.product-image', '');

const scrollToThumbnail = (index) => {
    const thumbnailsList = document.querySelector('.sourcing-thumbnails');
    if (!thumbnailsList) return;
    
    const thumbnails = thumbnailsList.children;
    if (!thumbnails[index]) return;
    
    // For first thumbnail, scroll to top
    if (index === 0) {
        thumbnailsList.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        return;
    }
    
    // For last thumbnail, scroll to bottom
    if (index === thumbnails.length - 1) {
        thumbnailsList.scrollTo({
            top: thumbnailsList.scrollHeight,
            behavior: 'smooth'
        });
        return;
    }
    
    // For all other thumbnails, center them
    thumbnails[index].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
    });
};

const handleThumbnailClick = (index) => {
    selectedImage.value = index;
    scrollToThumbnail(index);
};
</script>

<style scoped>
.carousel-button {
    @apply opacity-40 hover:opacity-100 duration-150 p-1 active:bg-gray-225 at1024:active:bg-gray-225 at1024:hover:bg-gray-150 rounded-full disabled:pointer-events-none disabled:opacity-10;
}

.sourcing-thumbnails {
    mask-image: linear-gradient(to bottom, transparent 0%, black 5%, black 95%, transparent 100%);
    -webkit-mask-image: linear-gradient(to bottom, transparent 0%, black 5%, black 95%, transparent 100%);
}
</style>
